import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { dataSummary, dataSummary_currency, summary_currency_other, summary_currency_other_new } from "@/api/dataAll/dataSummary";
import { screenDataAdd, screenDataGet } from "@/api/user";
import * as echarts from "echarts";
export default {
  name: "dataSummaryScreenTherr",
  mixins: [tabulation],
  data: function data() {
    return {
      searchData: {
        kind: 1,
        all_countries: 0
      },
      PercentageUnit: ["CR", "PR", "NPR", "pay_account_percent", "sameday", "otherday"],
      pageData: {},
      tableData: [],
      dates: [],
      DNU_DAU: [],
      DND_DNU: [],
      screenArr: [{
        label: "日期.Date",
        prop: "date",
        isfixed: true,
        classname: "font-bold",
        tabText: "2020-01-01"
      }, {
        label: "总收入.Revenue",
        prop: "recharge_account_amount",
        tabText: "RevenueA",
        desc: "包含IAP内购和IAA广告收入的总流水收入"
      }, {
        label: "内购付费收入.Rev-IAP",
        prop: "Rev-IAP",
        tabText: "内购付费收入A",
        desc: "通过内购充值的付费总额"
      }, {
        label: "活跃账号.DAU",
        prop: "active_account_num",
        tabText: "活跃账号A",
        desc: "当日登录过所有账号数"
      }, {
        label: "新增账号.DNU",
        prop: "new_account_num",
        tabText: "新增账号A",
        desc: "当日新增的账号数"
      }, {
        label: "新增活跃比",
        prop: "DNU_DAU",
        tabText: "新增活跃比A",
        desc: "DNU/DAU"
      }, {
        label: "非新增活跃账号数",
        prop: "DAU_DNU",
        tabText: "非新增活跃账号数",
        desc: "DAU-DNU "
      }, {
        label: "付费账号数.DPU",
        prop: "recharge_account_num",
        tabText: "付费账号数A",
        desc: "当日有过付费的账号数"
      }, {
        label: "活跃付费率.PR",
        prop: "PR",
        tabText: "活跃付费率A",
        desc: "付费账号数/活跃账号"
      }, // {
      //   label: '付费率.PUR',
      //   prop: 'pay_account_percent',
      //   tabText: '付费率'
      // },
      {
        label: "活跃用户人均付费.ARPU",
        prop: "pay_account_arpu",
        tabText: "活跃用户人均付费A",
        desc: "内购付费收入/活跃账号"
      }, {
        label: "付费用户人均付费.ARPPU",
        prop: "pay_account_arppu",
        tabText: "付费用户人均付费A",
        desc: "内购付费收入/内购付费账号数"
      }, {
        label: "新增设备.DND",
        prop: "new_device_num",
        tabText: "新增设备A",
        desc: "游戏上报的激活设备数"
      }, {
        label: "新增设备账号比",
        prop: "DND_DNU",
        tabText: "新增设备账号比A",
        desc: "DND/DNU"
      }, {
        label: "新增账号付费总额.RevNU",
        prop: "register_recharge_amount",
        tabText: "新增账号付费总额A",
        desc: "新增账号内购总付费"
      }, {
        label: "新增付费账号数.PNU",
        prop: "register_recharge_pnum",
        tabText: "新增付费账号数A",
        desc: "新增账号有付费的账号数"
      }, {
        label: "新增付费率.NPR",
        prop: "NPR",
        tabText: "新增付费率A",
        desc: "新增付费账号数/新增账号"
      }, // {
      //   label: '登录账号',
      //   prop: 'login_account_num',
      //   tabText: '登录账号'
      // },
      {
        label: "新增账号人均付费.ARPNU",
        prop: "arpnu",
        tabText: "新增账号人均付费A",
        desc: "新增账号付费总额/新增账号"
      }, {
        label: "新增付费账号人均付费.ARPPNU",
        prop: "arppnu",
        tabText: "新增付费账号人均付费A",
        desc: "新增账号付费总额/新增付费账号数"
      }, {
        label: "新增设备付费金额",
        prop: "new_device_recharge_amount",
        tabText: "新增设备付费金额",
        desc: ""
      }, {
        label: "新增设备付费数",
        prop: "new_device_recharge_num",
        tabText: "新增设备付费数",
        desc: ""
      }, {
        label: "买量消耗",
        prop: "cost",
        tabText: "买量消耗A",
        desc: "当日总广告投放消耗"
      }, {
        label: "新增安装量.Install",
        prop: "Install",
        tabText: "新增安装量A",
        desc: "投放平台返回的总激活数:新增投放量+新增自然量"
      }, {
        label: "新增投放量.I-Ads",
        prop: "I-Ads",
        tabText: "新增投放量A",
        desc: "投放平台返回的通过广告激活的用户数"
      }, {
        label: "新增自然量.I-Organic",
        prop: "I-Organic",
        tabText: "I-OrganicA",
        desc: "投放平台返回的非广告自然量"
      }, {
        label: "自然量K因子.K-Factory",
        prop: "K-Factory",
        tabText: "自然量K因子A",
        desc: "广告量与自然量比值:新增自然量/新增投放量"
      }, {
        label: "安装注册转化率.CR",
        prop: "CR",
        tabText: "安装注册转化率A",
        desc: "安装到注册的转化率:新增账号/新增安装量"
      }, {
        label: "新增安装成本.eCPI",
        prop: "eCPI",
        tabText: "新增安装成本A",
        desc: "买量消耗/新增安装量"
      }, {
        label: "新增账号成本.eCPA",
        prop: "eCPA",
        tabText: "新增账号成本A",
        desc: "买量消耗/新增账号数"
      }, {
        label: "新增次留成本.eCPR",
        prop: "eCPR",
        tabText: "新增次流成本A",
        desc: "买量消耗/次留用户数"
      }, {
        label: "新增付费成本.eCPP",
        prop: "eCPP",
        tabText: "新增付费成本A",
        desc: "买量消耗/新增付费人数"
      }, {
        label: "广告收入.Rev-IAA",
        prop: "Rev-IAA",
        tabText: "广告收入A",
        desc: "通过广告获得的收入"
      }, {
        label: "活跃人均贡献.DARPU",
        prop: "DARPU",
        tabText: "活跃人均贡献A",
        desc: "总收入/活跃账号"
      }, {
        label: "次留用户数",
        prop: "eCPR_count",
        tabText: "次留用户数A",
        desc: "次留用户数"
      }],
      defaultNotShown: ["DNU_DAU", "DND_DNU", "DAU_DNU", "arpnu", "arppnu", "K-Factory", "eCPA", "eCPR", "eCPP", "eCPR_count", "new_device_recharge_amount", "new_device_recharge_num"],
      defaultNotShownL_R_R: [],
      LTVList: [],
      acLTVList: [],
      ROIList: [],
      acROIList: [],
      RRList: [],
      acRRList: [],
      screen: [],
      sericeArr: [],
      otherArr: [],
      isShow: true,
      wxProp: [{
        label: "安卓充值",
        prop: "android_recharge",
        isfixed: false,
        tabText: "安卓充值"
      }, {
        label: "IOS充值",
        prop: "iOS_recharge",
        isfixed: false,
        tabText: "IOS充值"
      }],
      countryPro: [{
        label: "国家.Country",
        prop: "country",
        isfixed: false,
        tabText: ""
      }],
      countryAllList: [{
        label: "默认",
        value: 0
      }, {
        label: "所有国家",
        value: 1
      }],
      countryShow: false,
      cellStylekeys: ["ROI", "RR", "LTV", "acLTV", "acRR"],
      // 相加汇总数据
      additionList: ["recharge_account_amount", "Rev-IAP", "DNU_DAU", "active_account_num", "new_account_num", "register_recharge_pnum", "DAU_DNU", "recharge_account_num", "new_device_num", "register_recharge_amount", "new_device_recharge_amount", "new_device_recharge_num", "cost", "Install", "I-Ads", "I-Organic", "Rev-IAA", "eCPR_count"],
      // 相除汇总数据
      compute: [{
        // 活跃付费率  付费账号数/活跃账号
        prop: "PR",
        divisor: "recharge_account_num",
        dividend: "active_account_num"
      }, {
        // 活跃用户人均付费  内购付费收入 / 活跃账号
        prop: "pay_account_arpu",
        divisor: "Rev-IAP",
        dividend: "active_account_num"
      }, {
        // 付费用户人均付费  内购付费收入 / 内购付费账号数
        prop: "pay_account_arppu",
        divisor: "Rev-IAP",
        dividend: "recharge_account_num"
      }, {
        // 新增设备账号比  新增设备  /  新增账号 
        prop: "DND_DNU",
        divisor: "new_device_num",
        dividend: "new_account_num"
      }, {
        // 新增付费率     新增付费账号数 /  新增账号
        prop: "NPR",
        divisor: "register_recharge_pnum",
        dividend: "new_account_num"
      }, {
        // 新增付费账号人均付费     新增账号付费总额 /  新增付费账号数
        prop: "arppnu",
        divisor: "register_recharge_amount",
        dividend: "register_recharge_pnum"
      }, {
        // 新增账号人均付费   新增账号付费总额 / 新增账号
        prop: "arpnu",
        divisor: "register_recharge_amount",
        dividend: "new_account_num"
      }, {
        // 自然量K因子   新增自然量 / 新增投放量
        prop: "K-Factory",
        divisor: "I-Organic",
        dividend: "I-Ads"
      }, {
        // 安装注册转化率  新增账号 / 新增安装量
        prop: "CR",
        divisor: "new_account_num",
        dividend: "Install"
      }, {
        // 新增安装成本  买量消耗 / 新增安装量
        prop: "eCPI",
        divisor: "cost",
        dividend: "Install"
      }, {
        // 新增账号成本  买量消耗 / 新增账号数
        prop: "eCPA",
        divisor: "cost",
        dividend: "new_account_num"
      }, {
        // 新增次留成本  买量消耗 / 次留用户数
        prop: "eCPR",
        divisor: "cost",
        dividend: "eCPR_count"
      }, {
        // 新增付费成本   买量消耗 / 新增付费人数
        prop: "eCPP",
        divisor: "cost",
        dividend: "register_recharge_pnum"
      }, {
        // 活跃人均贡献   总收入 / 活跃账号
        prop: "DARPU",
        divisor: "recharge_account_amount",
        dividend: "active_account_num"
      }],
      screenData: null,
      screenDataShow: false
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return screenDataGet();

            case 2:
              _this.screenData = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 初始化表头数据
    initscreenArr: function initscreenArr() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.otherArr = [];
        _this2.PercentageUnit = ["CR", "PR", "NPR", "pay_account_percent", "sameday", "otherday"];

        _this2.LTVList.forEach(function (i) {
          _this2.otherArr.push({
            label: "LTV" + i,
            prop: "LTV" + i,
            tabText: "LTV" + (i == 1 ? "".concat(i, "A") : i),
            desc: i == 1 ? "首日用户平均价值" : ""
          });
        });

        _this2.acLTVList.forEach(function (i) {
          _this2.otherArr.push({
            label: "激活设备LTV" + i,
            prop: "acLTV" + i,
            tabText: "激活设备LTV" + (i == 1 ? "".concat(i, "A") : i),
            desc: i == 1 ? "首日激活设备平均价值" : ""
          });
        });

        _this2.ROIList.forEach(function (i) {
          _this2.otherArr.push({
            label: "ROI" + i,
            prop: "ROI" + i,
            tabText: "ROI" + (i == 1 ? "".concat(i, "A") : i),
            desc: i == 1 ? "首日投放回本率" : ""
          });
        }); // this.acROIList.forEach((i) => {
        //   this.otherArr.push({
        //     label: "激活设备ROI" + i,
        //     prop: "acROI" + i,
        //     tabText: "激活设备ROI" + (i == 1 ? `${i}A` : i),
        //     desc: i == 1 ? "首日激活设备投放回本率" : "",
        //   });
        // });


        _this2.RRList.forEach(function (i) {
          _this2.otherArr.push({
            label: "RR" + i,
            prop: "RR" + i,
            tabText: "RR" + (i == 2 ? "".concat(i, "A") : i),
            desc: i == 2 ? "次日留存率" : ""
          });

          _this2.PercentageUnit.push("RR" + i);
        });

        _this2.acRRList.forEach(function (i) {
          _this2.otherArr.push({
            label: "激活设备RR" + i,
            prop: "acRR" + i,
            tabText: "激活设备RR" + (i == 2 ? "".concat(i, "A") : i),
            desc: i == 2 ? "次日留存率" : ""
          });

          _this2.PercentageUnit.push("acRR" + i);
        });

        _this2.defaultNotShownL_R_R.forEach(function (i) {
          _this2.defaultNotShown.push("LTV" + i);

          _this2.defaultNotShown.push("acLTV" + i);

          _this2.defaultNotShown.push("ROI" + i);

          _this2.defaultNotShown.push("RR" + i);

          _this2.defaultNotShown.push("acRR" + i);
        });

        resolve();
      });
    },
    screenControls: function screenControls() {
      var _this3 = this;

      this.isShow = false;
      var list = [];
      this.screenArr.forEach(function (i) {
        if (_this3.screen.findIndex(function (t) {
          return t == i.prop;
        }) !== -1) {
          list.push(i);
        }
      });
      this.sericeArr = list;

      if (this.tableData.length) {
        setTimeout(function () {
          _this3.isShow = true;

          _this3.$nextTick(function () {
            _this3.columnDropInit();
          });
        }, 200);
        this.getechart();
      }

      screenDataAdd({
        data: JSON.stringify(list)
      });
      this.$nextTick(function () {
        _this3.setTableRight(0);
      }); // this.$store.commit("d2admin/serchSelect/setsericeArr", list);
    },
    // 重置筛选
    ResetFilter: function ResetFilter() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var newArr;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.loopSearch();

              case 2:
                newArr = _this4.screenArr.filter(function (item) {
                  return !_this4.defaultNotShown.some(function (ele) {
                    return ele === item.prop;
                  });
                });
                _this4.screen = newArr.map(function (i) {
                  return i.prop;
                });

                _this4.screenControls();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    searchClickNs: function searchClickNs() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.timeInterval();

              case 2:
                reqFn = dataSummary;

                if (_this5.currencyClose && !_this5.searchData.pay_channel) {
                  reqFn = dataSummary_currency;
                } else if (_this5.searchData.pay_channel) {
                  reqFn = summary_currency_other;
                }

                _this5.searchClickPoints(summary_currency_other_new, 1);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    searchClick: function searchClick(lists) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var qres, res, list, clist, newArr, other, summaryDataCalculate, k, DNU_DAUDay, _k2, _k3, _k4, newData, country, key, i, _key, ds, _i, data, _loop, _key2;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                qres = JSON.parse(JSON.stringify(lists));
                res = {
                  data: {
                    data: {},
                    summary: {
                      LTV: {},
                      ROI: {},
                      acRRAvgData: {},
                      acdeLtv: {},
                      avgData: {},
                      data: {},
                      other: {}
                    }
                  }
                };
                res.data.summary = _objectSpread({}, qres[0].summary);
                /**
                 * 表头数据处理
                 */

                _this6.LTVList = Object.keys(qres[0].summary['LTV']);
                _this6.acLTVList = Object.keys(qres[0].summary['acdeLtv']);
                _this6.ROIList = Object.keys(qres[0].summary['ROI']);
                _this6.RRList = Object.keys(qres[0].summary['avgData']);
                _this6.acRRList = Object.keys(qres[0].summary['acRRAvgData']);
                _context4.next = 10;
                return _this6.initscreenArr();

              case 10:
                if (!_this6.screenDataShow) {
                  _this6.screenDataShow = true;
                  list = _this6.screenData.data ? JSON.parse(_this6.screenData.data) : []; // 去除原动态表头与历史表头不匹配的项

                  clist = [];
                  list.forEach(function (i) {
                    if (_this6.screenArr.findIndex(function (c) {
                      return c.prop == i.prop;
                    }) > -1) {
                      clist.push(i);
                    }
                  });
                  _this6.sericeArr = [].concat(clist);
                  _this6.screen = (list.length ? list : _this6.screenArr).map(function (item) {
                    return item.prop;
                  });

                  if (!list.length) {
                    newArr = _this6.screen.filter(function (item) {
                      return !_this6.defaultNotShown.some(function (ele) {
                        return ele === item;
                      });
                    });
                    _this6.screen = newArr;

                    _this6.screenControls();
                  }
                } // 


                qres.map(function (i) {
                  i.summary.summaryDataCalculate = i.summary.summaryDataCalculate ? i.summary.summaryDataCalculate : i.summaryDataCalculate;
                });
                _this6.dates = [];
                other = {
                  "recharge_account_amount": 0,
                  "active_account_num": 0,
                  "new_account_num": 0,
                  "recharge_account_num": 0,
                  "pay_account_arpu": 0,
                  "pay_account_arppu": 0,
                  "new_device_num": 0,
                  "register_recharge_amount": 0,
                  "register_recharge_pnum": 0,
                  "arpnu": 0,
                  "arppnu": 0,
                  "cost": 0,
                  "Install": 0,
                  "I-Ads": 0,
                  "I-Organic": 0,
                  "K-Factory": 0,
                  "CR": 0,
                  "PR": 0,
                  "NPR": 0,
                  "Rev-IAP": 0,
                  "Rev-IAA": 0,
                  "DARPU": 0,
                  "eCPI": 0,
                  "eCPA": 0,
                  "eCPR": 0,
                  "eCPP": 0,
                  "eCPR_count": 0,
                  "android_recharge": 0,
                  "iOS_recharge": 0,
                  "new_device_recharge_num": 0,
                  "new_device_recharge_amount": 0,
                  "DNU_DAU": 0,
                  "DAU_DNU": 0,
                  "DND_DNU": 0
                }; // qres[0].summary.summaryDataCalculate = qres[0].summary.summaryDataCalculate ? qres[0].summary.summaryDataCalculate : qres[0].summaryDataCalculate 

                summaryDataCalculate = {
                  ltv_amount: qres[0].summary.summaryDataCalculate.ltv_amount.map(function (j) {
                    return 0;
                  }),
                  acdevice_ltv_amount: qres[0].summary.summaryDataCalculate.acdevice_ltv_amount.map(function (j) {
                    return 0;
                  }),
                  register_people_num: 0,
                  activity_devicere_num: 0,
                  active_people_num_count: 0,
                  activity_devicere_retain_num: {},
                  retain_num: {}
                };

                for (k in qres[0].summary.summaryDataCalculate.retain_num) {
                  summaryDataCalculate.retain_num[k] = 0;
                  summaryDataCalculate.activity_devicere_retain_num[k] = 0;
                }

                DNU_DAUDay = 0;
                qres.forEach(function (i) {
                  res.data.data = _objectSpread(_objectSpread({}, res.data.data), i.data);

                  if (i.summary.other['DNU_DAU']) {
                    DNU_DAUDay = DNU_DAUDay + 1;
                  }

                  _this6.additionList.forEach(function (j) {
                    other[j] = Number(other[j]) + Number(i.summary.other[j]);
                  });

                  i.summary.summaryDataCalculate.ltv_amount.forEach(function (j, ji) {
                    summaryDataCalculate.ltv_amount[ji] = summaryDataCalculate.ltv_amount[ji] + j;
                  });
                  i.summary.summaryDataCalculate.acdevice_ltv_amount.forEach(function (j, ji) {
                    summaryDataCalculate.acdevice_ltv_amount[ji] = summaryDataCalculate.acdevice_ltv_amount[ji] + j;
                  });

                  for (var _k in i.summary.summaryDataCalculate.retain_num) {
                    summaryDataCalculate.retain_num[_k] = Number(summaryDataCalculate.retain_num[_k]) + Number(i.summary.summaryDataCalculate.retain_num[_k]);
                    summaryDataCalculate.activity_devicere_retain_num[_k] = Number(summaryDataCalculate.activity_devicere_retain_num[_k]) + Number(i.summary.summaryDataCalculate.activity_devicere_retain_num[_k]);
                  }

                  summaryDataCalculate.register_people_num = summaryDataCalculate.register_people_num + i.summary.summaryDataCalculate.register_people_num;
                  summaryDataCalculate.activity_devicere_num = summaryDataCalculate.activity_devicere_num + i.summary.summaryDataCalculate.activity_devicere_num;
                  summaryDataCalculate.active_people_num_count = summaryDataCalculate.active_people_num_count + i.summary.summaryDataCalculate.active_people_num_count;
                });

                _this6.compute.forEach(function (i) {
                  var n = (other[i.dividend] == 0 ? 0 : other[i.divisor] / other[i.dividend]).toFixed(4);
                  other[i.prop] = n == '0.000' ? 0.000 : n.slice(0, n.length - 1);
                });

                other['DNU_DAU'] = DNU_DAUDay == 0 ? '0.000' : other['DNU_DAU'] / DNU_DAUDay; // LTV

                for (_k2 in res.data.summary.LTV) {
                  res.data.summary.LTV[_k2] = summaryDataCalculate.register_people_num == 0 ? 0 : summaryDataCalculate.ltv_amount[Number(_k2) - 1] / summaryDataCalculate.register_people_num;
                  res.data.summary.acdeLtv[_k2] = summaryDataCalculate.activity_devicere_num == 0 ? 0 : summaryDataCalculate.acdevice_ltv_amount[Number(_k2) - 1] / summaryDataCalculate.activity_devicere_num;
                } // ROI


                for (_k3 in res.data.summary.ROI) {
                  res.data.summary.ROI[_k3] = other.cost == 0 ? 0 : summaryDataCalculate.ltv_amount[Number(_k3) - 1] / other.cost;
                } // 留存


                for (_k4 in res.data.summary.avgData) {
                  res.data.summary.avgData[_k4] = ((summaryDataCalculate.register_people_num == 0 ? 0 : summaryDataCalculate.retain_num[_k4] / summaryDataCalculate.register_people_num) * 100).toFixed(2) + '%';
                  res.data.summary.acRRAvgData[_k4] = ((summaryDataCalculate.activity_devicere_num == 0 ? 0 : summaryDataCalculate.activity_devicere_retain_num[_k4] / summaryDataCalculate.activity_devicere_num) * 100).toFixed(2) + '%';
                }

                res.data.summary.other = _objectSpread({}, other);
                _this6.isShow = true;
                _this6.tableData = [];
                newData = {};

                if (!(JSON.stringify(res.data.data) == "[]")) {
                  _context4.next = 29;
                  break;
                }

                return _context4.abrupt("return");

              case 29:
                // 改为
                res.data.summary.data = res.data.summary.avgData;
                res.data.summary.acRR = res.data.summary.acRRAvgData;
                country = _this6.searchData.country.length ? _this6.searchData.country : [];

                if (_this6.searchData.all_countries == 1) {
                  country = res.data.countryList; // for(let i in res.data.data){
                  //   for(let k in res.data.data[i]['LTV']){
                  //     country.push(k)
                  //   }
                  //   break
                  // }
                } // 数据重组


                if (_this6.searchData.country.length || _this6.searchData.all_countries == 1) {
                  if (country.length) {
                    country.forEach(function (item) {
                      for (var key in res.data.data) {
                        for (var jkey in res.data.data[key]) {
                          if (res.data.data[key][jkey][item]) {
                            newData[key + "/" + item] = !newData[key + "/" + item] ? {} : newData[key + "/" + item];
                            newData[key + "/" + item][jkey] = jkey !== "other" ? _objectSpread({}, res.data.data[key][jkey][item]) : _objectSpread(_objectSpread({}, res.data.data[key][jkey][item]), {}, {
                              country: item
                            });
                          }
                        }
                      }
                    });
                    newData["总计"] = res.data.summary;
                  }
                } else {
                  newData = res.data.data;
                  newData["总计"] = res.data.summary;
                }

                console.log(newData, 'newData');
                _this6.countryShow = _this6.searchData.all_countries == 1 || _this6.searchData.country.length ? true : false;
                _this6.pageData = _objectSpread({}, newData); // 初始化折线图数据

                _context4.t0 = regeneratorRuntime.keys(newData);

              case 38:
                if ((_context4.t1 = _context4.t0()).done) {
                  _context4.next = 51;
                  break;
                }

                key = _context4.t1.value;

                for (i in newData[key].other) {
                  _this6[i] = [];
                }

                _this6.LTVList.forEach(function (i) {
                  _this6["LTV" + i] = [];
                });

                _this6.acLTVList.forEach(function (i) {
                  _this6["acLTV" + i] = [];
                });

                _this6.ROIList.forEach(function (i) {
                  _this6["ROI" + i] = [];
                }); // this.acROIList.forEach((i) => {
                //   this["acROI" + i] = [];
                // });


                _this6.RRList.forEach(function (i) {
                  _this6["RR" + i] = [];
                });

                _this6.acRRList.forEach(function (i) {
                  _this6["acRR" + i] = [];
                });

                _this6["DNU_DAU"] = [];
                _this6["DND_DNU"] = [];
                return _context4.abrupt("break", 51);

              case 51:
                // 数据赋值
                for (_key in newData) {
                  _this6.dates.push(_key);

                  newData[_key].other.pay_account_arpu = _this6.$utils.conversion(newData[_key].other.pay_account_arpu).toFixed(3);
                  newData[_key].other.pay_account_arppu = _this6.$utils.conversion(newData[_key].other.pay_account_arppu).toFixed(2);
                  newData[_key].other.recharge_account_amount = _this6.$utils.conversion(newData[_key].other.recharge_account_amount).toFixed(2);
                  newData[_key].other.register_recharge_amount = _this6.$utils.conversion(newData[_key].other.register_recharge_amount).toFixed(2);
                  newData[_key].other["Rev-IAA"] = _this6.$utils.conversion(newData[_key].other["Rev-IAA"]).toFixed(2);
                  newData[_key].other["Rev-IAP"] = _this6.$utils.conversion(newData[_key].other["Rev-IAP"]).toFixed(2);
                  newData[_key].other["DARPU"] = _this6.$utils.conversion(newData[_key].other["DARPU"]).toFixed(2);
                  newData[_key].other["eCPI"] = _this6.$utils.conversion(newData[_key].other["eCPI"]).toFixed(2);
                  newData[_key].other["eCPA"] = _this6.$utils.conversion(newData[_key].other["eCPA"]).toFixed(2);
                  newData[_key].other["eCPR"] = _this6.$utils.conversion(newData[_key].other["eCPR"]).toFixed(2);
                  newData[_key].other["eCPP"] = _this6.$utils.conversion(newData[_key].other["eCPP"]).toFixed(2);
                  newData[_key].other["cost"] = _this6.$utils.conversion(newData[_key].other["cost"]).toFixed(2);
                  newData[_key].other["new_device_recharge_amount"] = _this6.$utils.conversion(newData[_key].other["new_device_recharge_amount"]).toFixed(2); // newData[key].other.pay_account_percent = ((newData[key].other.pay_account_percent - 0) * 100).toFixed(2);

                  newData[_key].other.arpnu = _this6.$utils.conversion(newData[_key].other.arpnu).toFixed(3);
                  newData[_key].other.arppnu = _this6.$utils.conversion(newData[_key].other.arppnu).toFixed(3); // newData[key].other.sameday = this.zhuan(newData[key].other.sameday,1);
                  // newData[key].other.otherday = this.zhuan(newData[key].other.otherday,2);

                  ds = _this6.compute.find(function (i) {
                    return i.prop == 'CR';
                  });
                  newData[_key].other[ds.prop] = newData[_key].other[ds.dividend] == 0 ? 0 : newData[_key].other[ds.divisor] / newData[_key].other[ds.dividend]; // let n = (newData[key].other.CR * 100).toFixed(3)
                  // newData[key].other.CR = n == '0.000' ? 0.000 : n.slice(0, n.length - 1);

                  newData[_key].other.CR = (newData[_key].other.CR * 100).toFixed(2);
                  newData[_key].other.PR = (newData[_key].other.PR * 100).toFixed(2);
                  newData[_key].other.NPR = (newData[_key].other.NPR * 100).toFixed(2);
                  newData[_key].other['K-Factory'] = Number(newData[_key].other['K-Factory']).toFixed(3);
                  newData[_key].other['DNU_DAU'] = Number(newData[_key].other['DNU_DAU']).toFixed(3);
                  newData[_key].other['DND_DNU'] = Number(newData[_key].other['DND_DNU']).toFixed(3);

                  if (_this6.searchData.channel == "wxminigame") {
                    newData[_key].other.android_recharge = (newData[_key].other.android_recharge / 100).toFixed(2);
                    newData[_key].other.iOS_recharge = (newData[_key].other.iOS_recharge / 100).toFixed(2);
                  }

                  for (_i in newData[_key].other) {
                    _this6[_i].push(newData[_key].other[_i]);
                  }
                }

                data = JSON.parse(JSON.stringify(_this6.pageData));

                _loop = function _loop(_key2) {
                  var arr = {};

                  _this6.screenArr.forEach(function (item) {
                    arr[item.prop] = data[_key2].other[item.prop] || 0;
                  });

                  if (_this6.searchData.channel == "wxminigame") {
                    arr["android_recharge"] = data[_key2].other["android_recharge"];
                    arr["iOS_recharge"] = data[_key2].other["iOS_recharge"];
                  }

                  if (_this6.countryShow) {
                    arr["country"] = data[_key2].other["country"];
                  } // LTV


                  var ltvData = {};

                  for (var li in data[_key2].LTV) {
                    var num = data[_key2].LTV[li] !== "/" ? _this6.$utils.conversion(data[_key2].LTV[li]).toFixed(3) : "0.000"; // let num = this.$utils.conversion('4.5').toFixed(2)

                    ltvData["LTV" + li] = num;

                    _this6["LTV" + li].push(num);
                  } // 激活设备LTV


                  var acltvData = {};

                  for (var _li in data[_key2].acdeLtv) {
                    var _num = data[_key2].acdeLtv[_li] !== "/" ? _this6.$utils.conversion(data[_key2].acdeLtv[_li]).toFixed(3) : "0.000"; // let num = this.$utils.conversion('4.5').toFixed(2)


                    acltvData["acLTV" + _li] = _num;

                    _this6["acLTV" + _li].push(_num);
                  } // ROI


                  var roiData = {};

                  for (var _li2 in data[_key2].ROI) {
                    roiData["ROI" + _li2] = Number(data[_key2].ROI[_li2]).toFixed(3);

                    _this6["ROI" + _li2].push(Number(data[_key2].ROI[_li2]).toFixed(3));
                  } // 激活设备ROI
                  // let acroiData = {};
                  // for (let li in data[key].ROI) {
                  //   acroiData["ROI" + li] = Number(data[key].ROI[li]).toFixed(3);
                  //   this["ROI" + li].push(Number(data[key].ROI[li]).toFixed(3));
                  // }
                  // RR


                  var rrData = {};

                  var _loop2 = function _loop2(_li3) {
                    var nums = Number(_li3);

                    if (_this6.RRList.findIndex(function (i) {
                      return i == nums;
                    }) > -1) {
                      var _num2 = data[_key2].data[_li3] == "/" ? 0 : _this6.zhuan(data[_key2].data[_li3], 3);

                      rrData["RR" + nums] = _num2;

                      _this6["RR" + nums].push(_num2);
                    }
                  };

                  for (var _li3 in data[_key2].data) {
                    _loop2(_li3);
                  } // acRR


                  var acrrData = {};

                  var _loop3 = function _loop3(_li4) {
                    var nums = Number(_li4);

                    if (_this6.acRRList.findIndex(function (i) {
                      return i == nums;
                    }) > -1) {
                      var _num3 = data[_key2].acRR[_li4] == "/" ? 0 : _this6.zhuan(data[_key2].acRR[_li4], 4);

                      acrrData["acRR" + nums] = _num3;

                      _this6["acRR" + nums].push(_num3);
                    }
                  };

                  for (var _li4 in data[_key2].acRR) {
                    _loop3(_li4);
                  }

                  _this6.tableData.push(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, arr), ltvData), roiData), rrData), acrrData), acltvData), {}, {
                    date: _key2
                  }));
                };

                for (_key2 in data) {
                  _loop(_key2);
                }

                _this6.tableData.reverse();

                _this6.tableData.map(function (item) {
                  item.date = item.date.split("/")[0];
                  item.timeStamp = _this6.$times.timeStamp(item.date) || 999999999999999;
                });

                _this6.tableData.sort(function (a, b) {
                  return b.timeStamp < a.timeStamp ? 1 : -1;
                }); // this.sericeArr = this.sericeArr.length ? this.sericeArr : this.screenArr;
                // if (this.searchData.channel == 'wxminigame' ) {
                //   wxProp.unshift(1, 0)
                //   Array.prototype.splice.apply(this.sericeArr, wxProp);
                // }


                _this6.$nextTick(function () {
                  _this6.columnDropInit();

                  _this6.getTableRight();

                  _this6.getechart();
                });

              case 59:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    zhuan: function zhuan(data, t) {
      // let n = []
      // list.forEach((item) => {
      //   n.push(item.length > 0 ? Number(item.substr(0, item.length - 1)) : 0)
      // })
      var d = 0;

      if (data) {
        d = Number(data.substr(0, data.length - 1));
      }

      return d;
    },
    getechart: function getechart() {
      var _this7 = this;

      var chartDom = document.getElementById("dataSummaryScreenEchart");
      var myChart = echarts.init(chartDom);
      var date = JSON.parse(JSON.stringify(this.dates)).splice(0, this.dates.length - 1);
      var newDate = [];
      date.forEach(function (item, index) {
        var strL = item.split("/");
        newDate[index] = {
          date: strL[0],
          timeStamp: _this7.$times.timeStamp(strL[0]),
          country: strL[1]
        };
      });
      newDate.reverse();
      newDate.sort(function (a, b) {
        return b.timeStamp < a.timeStamp ? 1 : -1;
      });
      var newDates = newDate.map(function (i) {
        return i.country ? i.date + "/" + i.country : i.date;
      });
      var newSericeArr = JSON.parse(JSON.stringify([].concat(_toConsumableArray(this.sericeArr), _toConsumableArray(this.otherArr))));
      var wxProp = JSON.parse(JSON.stringify(this.wxProp));

      if (this.searchData.channel == "wxminigame") {
        wxProp.unshift(1, 0);
        Array.prototype.splice.apply(newSericeArr, wxProp);
      }

      var option;
      var legendArr = [];
      var sericeArr = [];
      newSericeArr.forEach(function (item) {
        if (item.prop !== "date") {
          var label = item.label.split(".")[0];
          legendArr.push(label);
          sericeArr.push({
            name: label,
            type: "line",
            data: JSON.parse(JSON.stringify(_this7[item.prop])).splice(0, _this7[item.prop].length - 1),
            smooth: true
          });
        }
      });
      option = {
        title: {
          text: "数据汇总"
        },
        animationDuration: 3000,
        tooltip: {
          trigger: "axis",
          confine: true,
          formatter: function formatter(params) {
            var astr = "";
            astr += "".concat(params[0].axisValue, "<br/>");
            params.forEach(function (ele, index) {
              astr += "<div style=\"display: block;height:20px;".concat(index % 3 === 0 ? "width: 33%;" : "width: 33%;", "float:left;\">\n                        <i style=\"width: 10px;height: 10px;display: inline-block;background: ").concat(ele.color, ";border-radius: 10px;\"></i>\n                        <span>").concat(ele.seriesName, ": ").concat(ele.data, "</span>\n                        </div>");
            });
            var b = '<div style="width: 640px;">' + astr + "<div>";
            return b;
          }
        },
        legend: {
          data: legendArr,
          width: "100%",
          top: "4%",
          icon: "circle",
          itemHeight: 12,
          itemWidth: 15,
          inactiveColor: "#666666",
          formatter: ["{a|{name}}"].join("\n"),
          textStyle: {
            fontSize: 12,
            lineHeight: 12,
            rich: {
              a: {
                width: 120,
                verticalAlign: "middle"
              }
            },
            padding: [0, 0, -2, -4] //[上、右、下、左]

          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "26%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: newDates
        },
        yAxis: {
          type: "value"
        },
        series: sericeArr
      };
      chartDom && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      var _this8 = this;

      var d = JSON.parse(JSON.stringify(this.tableData));
      var newSericeArr = JSON.parse(JSON.stringify([].concat(_toConsumableArray(this.sericeArr), _toConsumableArray(this.otherArr))));
      var wxProp = JSON.parse(JSON.stringify(this.wxProp));

      if (this.searchData.channel == "wxminigame") {
        wxProp.unshift(1, 0);
        Array.prototype.splice.apply(newSericeArr, wxProp);
      }

      var columns = _toConsumableArray(newSericeArr);

      if (this.countryShow) {
        columns.splice(1, 0, {
          label: "国家",
          prop: "country"
        });
      }

      d.map(function (item) {
        _this8.PercentageUnit.forEach(function (i) {
          item[i] = item[i] + "%";
        });
      });
      var data = d;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};